import { useMediaQuery } from '@mui/material';
import { Tooltip, Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { useState } from 'react';

const isTouchDevice = () => {
  return typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
};

type MotifCellProps = {
    motif: string | null;
};
 const MotifCell = ({ motif }:MotifCellProps) => {
  const [open, setOpen] = useState(false);
  const isTouch = isTouchDevice();

  const handleClick = () => {
    if (isTouch) setOpen(true);
  };

  return (
    <>
      <Tooltip title={motif || 'Aucun motif'} arrow disableHoverListener={isTouch}>
        <span onClick={handleClick} style={{ cursor: isTouch ? 'pointer' : 'default' }}>
          Voir Motif
        </span>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Motif</DialogTitle>
        <DialogContent>
          {motif || 'Aucun motif'}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MotifCell;